
<div ref="lineage-container" class="flow-lineage-container">
	<div class="flow-lineage-header">
		<slot name="header" />
	</div>
	<div :id="id" ref="lineage" class="flow-lineage-chart" />
	<div ref="lineage-popover">
		<slot v-if="popoverDataNode.id" name="popover" :d="popoverDataNode" :close="togglePopOver" />
	</div>
	<div :open="overlay" class="node-lineage-overlay" @click.stop="togglePopOver($event)" />
</div>
